/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Resources.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query'
import type {
  APIGatewayProxyRequest,
  AccountDisconnectionSummary,
  AssessmentDefinition,
  AssessmentRequest,
  AssessmentResultQueryResult,
  AssumeRolResult,
  AwsEffectiveTagPolicy,
  AwsEventBridgeHistoryQueryResult,
  AwsHierarchyEnrichment,
  AwsPolicyVersionInfo,
  AzureConnectingSubscriptionInfo,
  AzureConnectionRequest,
  AzureConnectionStatus,
  AzureSubscriptionConnectability,
  AzureSubscriptionConnection,
  AzureSubscriptionProvisioningJob,
  AzureTagPolicy,
  BaseResource,
  BaseResourceQueryResult,
  CheckAwsResources,
  CheckAwsResourcesJob,
  CheckAzureResources,
  CheckAzureResourcesJob,
  CliConnectionInfo,
  ConnectResult,
  FilteredResourceTypesAndCounts,
  GcpBillingExportInfo,
  GcpConnectionRequest,
  GcpConnectionStatus,
  GcpProjectConnectability,
  GcpProjectProvisioningJob,
  GcpToken,
  GetConnectionAzureConnectionCallbackParams,
  GetConnectionConnectionCompleteParams,
  GetConnectionGcpConnectionCallbackParams,
  GetConnectionGetAzureConnectionStatusParams,
  GetConnectionGetGcpConnectionStatusParams,
  GetConnectionScriptsCsCloudformationYmlParams,
  GetConnectionScriptsCsTerraformTfParams,
  GetConnectionScriptsUpdateCsCloudformationYmlParams,
  GetConnectionScriptsUpdateCsTerraformTfParams,
  GetConnectionTryAssumeRoleParams,
  GetMetadataIntegrationGetDimensionMetadataParams,
  GetMetadataIntegrationGetSchemaByCompanyIdParams,
  GetMetadataIntegrationParams,
  GetObservabilityGetMetricTypesParams,
  GetResourcesGetAwsPolicyResourceTypeMatrix200One,
  GetResourcesGetAwsPolicyResourceTypeMatrix200Three,
  GetResourcesGetAwsPolicyResourceTypeMatrix200Two,
  GetResourcesGetOrganizationalHierarchyByNameParams,
  GetResourcesGetOrganizationalHierarchyParams,
  GetResourcesGetPossibleChildrenOrDefaultParams,
  GetResourcesGetResourceHierarchyLookup200One,
  GetResourcesGetResourceHierarchyLookup200Three,
  GetResourcesGetResourceHierarchyLookup200Two,
  GetSavedSearchGetResourcesParams,
  GetSavedSearchGetResultsParams,
  MetadataIntegrationConfig,
  MetricQuery,
  MetricResults,
  ObjectQueryResult,
  OnDemandPricing,
  PendingCliConnection,
  PermissionList,
  PostAssessmentsSearchParams,
  PostConnectionAddAzureSubscriptionParams,
  PostConnectionApplyAzureTenantCredentialsParams,
  PostConnectionAuthorizeAzureConnectionParams,
  PostConnectionConnectParams,
  PostConnectionDisconnectAccountParams,
  PostConnectionDisconnectCloudsaverIntegrationParams,
  PostConnectionGetAzureSubscriptionConnectabilityStatusParams,
  PostConnectionGetGcpAccessTokenFromCodeParams,
  PostConnectionGetGcpBillingInfoParams,
  PostConnectionGetGcpProjectConnectabilityStatusParams,
  PostConnectionGetPendingConnectionParams,
  PostConnectionGetRoleYMLParams,
  PostConnectionPreparePolicyParams,
  PostConnectionRecordCLIErrorParams,
  PostConnectionSendConnectionConfirmationEmailParams,
  PostConnectionSendSecondaryAccountConnectionMessageParams,
  PostIdleActionStartIdleResourcesParams,
  PostIdleActionStopIdleResourcesParams,
  PostMetadataIntegrationSearchParams,
  PostObservabilityQueryParams,
  PostResourcePricingGetAwsAttributesParams,
  PostResourcePricingQueryAwsAttributesParams,
  PostResourceSnapshotQuerySnapshotsParams,
  PostResourcesBulkUpdateTagResourcesParams,
  PostResourcesCancelTaggingParams,
  PostResourcesGetChildResourcesParams,
  PostResourcesGetCompanyEventBridgeHistoryParams,
  PostResourcesGetParentResourceParams,
  PostResourcesMultiQueryParams,
  PostResourcesQueryParams,
  PostResourcesSearchParams,
  PostResourcesUpdateEventBridgeRulesParams,
  PostTagPolicyReimportAzureTagPoliciesParams,
  PreviewCountAndQuery,
  Query,
  ResourceChange,
  ResourceChangePreviewModel,
  ResourceChangeQueryResult,
  ResourceHierarchy,
  SavedSearchResults,
  SavedSearchToken,
  SchemaType,
  SelectedIdleResourceRequest,
  TagAutomationEvent,
  TagAutomationRule,
  TagJobEstimate,
  TagResourceResult,
  TagResourcesJob,
  TagResourcesJobJob
} from './Resources/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postAssessmentsStartAssessment = (
    assessmentRequest: AssessmentRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/Assessments/StartAssessment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assessmentRequest
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostAssessmentsStartAssessmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsStartAssessment>>, TError,{data: AssessmentRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsStartAssessment>>, TError,{data: AssessmentRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssessmentsStartAssessment>>, {data: AssessmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAssessmentsStartAssessment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssessmentsStartAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof postAssessmentsStartAssessment>>>
    export type PostAssessmentsStartAssessmentMutationBody = AssessmentRequest
    export type PostAssessmentsStartAssessmentMutationError = unknown

    export const usePostAssessmentsStartAssessment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsStartAssessment>>, TError,{data: AssessmentRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAssessmentsStartAssessment>>,
        TError,
        {data: AssessmentRequest},
        TContext
      > => {

      const mutationOptions = getPostAssessmentsStartAssessmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAssessmentsSearch = (
    query: Query,
    params?: PostAssessmentsSearchParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AssessmentResultQueryResult>(
      {url: `/Assessments/Search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostAssessmentsSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearch>>, TError,{data: Query;params?: PostAssessmentsSearchParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearch>>, TError,{data: Query;params?: PostAssessmentsSearchParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssessmentsSearch>>, {data: Query;params?: PostAssessmentsSearchParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAssessmentsSearch(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssessmentsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postAssessmentsSearch>>>
    export type PostAssessmentsSearchMutationBody = Query
    export type PostAssessmentsSearchMutationError = unknown

    export const usePostAssessmentsSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearch>>, TError,{data: Query;params?: PostAssessmentsSearchParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAssessmentsSearch>>,
        TError,
        {data: Query;params?: PostAssessmentsSearchParams},
        TContext
      > => {

      const mutationOptions = getPostAssessmentsSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAssessmentsSearchAll = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AssessmentResultQueryResult>(
      {url: `/Assessments/SearchAll`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostAssessmentsSearchAllMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearchAll>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearchAll>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssessmentsSearchAll>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postAssessmentsSearchAll(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssessmentsSearchAllMutationResult = NonNullable<Awaited<ReturnType<typeof postAssessmentsSearchAll>>>
    export type PostAssessmentsSearchAllMutationBody = Query
    export type PostAssessmentsSearchAllMutationError = unknown

    export const usePostAssessmentsSearchAll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearchAll>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAssessmentsSearchAll>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostAssessmentsSearchAllMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAssessmentsSearchTodaysAssessments = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AssessmentResultQueryResult>(
      {url: `/Assessments/SearchTodaysAssessments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostAssessmentsSearchTodaysAssessmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearchTodaysAssessments>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearchTodaysAssessments>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssessmentsSearchTodaysAssessments>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postAssessmentsSearchTodaysAssessments(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssessmentsSearchTodaysAssessmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postAssessmentsSearchTodaysAssessments>>>
    export type PostAssessmentsSearchTodaysAssessmentsMutationBody = Query
    export type PostAssessmentsSearchTodaysAssessmentsMutationError = unknown

    export const usePostAssessmentsSearchTodaysAssessments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsSearchTodaysAssessments>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAssessmentsSearchTodaysAssessments>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostAssessmentsSearchTodaysAssessmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAssessmentsQueryAssessments = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/Assessments/QueryAssessments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostAssessmentsQueryAssessmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsQueryAssessments>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsQueryAssessments>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssessmentsQueryAssessments>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postAssessmentsQueryAssessments(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssessmentsQueryAssessmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postAssessmentsQueryAssessments>>>
    export type PostAssessmentsQueryAssessmentsMutationBody = Query
    export type PostAssessmentsQueryAssessmentsMutationError = unknown

    export const usePostAssessmentsQueryAssessments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssessmentsQueryAssessments>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAssessmentsQueryAssessments>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostAssessmentsQueryAssessmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAssessmentsGetAssessmentDefinitions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AssessmentDefinition[]>(
      {url: `/Assessments/GetAssessmentDefinitions`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetAssessmentsGetAssessmentDefinitionsQueryKey = () => {
    return [`/Assessments/GetAssessmentDefinitions`] as const;
    }

    
export const getGetAssessmentsGetAssessmentDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssessmentsGetAssessmentDefinitionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>> = ({ signal }) => getAssessmentsGetAssessmentDefinitions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssessmentsGetAssessmentDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>>
export type GetAssessmentsGetAssessmentDefinitionsQueryError = unknown

export const useGetAssessmentsGetAssessmentDefinitions = <TData = Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssessmentsGetAssessmentDefinitions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAssessmentsGetAssessmentDefinitionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionGetCliConnectionInfo = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CliConnectionInfo>(
      {url: `/Connection/GetCliConnectionInfo`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionGetCliConnectionInfoQueryKey = () => {
    return [`/Connection/GetCliConnectionInfo`] as const;
    }

    
export const getGetConnectionGetCliConnectionInfoQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionGetCliConnectionInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>> = ({ signal }) => getConnectionGetCliConnectionInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionGetCliConnectionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>>
export type GetConnectionGetCliConnectionInfoQueryError = unknown

export const useGetConnectionGetCliConnectionInfo = <TData = Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetCliConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionGetCliConnectionInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsTokenAwsCsConnectorSh = (
    token: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/${token}/aws-cs-connector.sh`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsTokenAwsCsConnectorShQueryKey = (token: string,) => {
    return [`/Connection/scripts/${token}/aws-cs-connector.sh`] as const;
    }

    
export const getGetConnectionScriptsTokenAwsCsConnectorShQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>, TError = unknown>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsTokenAwsCsConnectorShQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>> = ({ signal }) => getConnectionScriptsTokenAwsCsConnectorSh(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsTokenAwsCsConnectorShQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>>
export type GetConnectionScriptsTokenAwsCsConnectorShQueryError = unknown

export const useGetConnectionScriptsTokenAwsCsConnectorSh = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>, TError = unknown>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorSh>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsTokenAwsCsConnectorShQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsTokenAwsCsConnectorPs1 = (
    token: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/${token}/aws-cs-connector.ps1`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsTokenAwsCsConnectorPs1QueryKey = (token: string,) => {
    return [`/Connection/scripts/${token}/aws-cs-connector.ps1`] as const;
    }

    
export const getGetConnectionScriptsTokenAwsCsConnectorPs1QueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>, TError = unknown>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsTokenAwsCsConnectorPs1QueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>> = ({ signal }) => getConnectionScriptsTokenAwsCsConnectorPs1(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsTokenAwsCsConnectorPs1QueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>>
export type GetConnectionScriptsTokenAwsCsConnectorPs1QueryError = unknown

export const useGetConnectionScriptsTokenAwsCsConnectorPs1 = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>, TError = unknown>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAwsCsConnectorPs1>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsTokenAwsCsConnectorPs1QueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsTokenAzureCsConnectorSh = (
    token: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/${token}/azure-cs-connector.sh`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsTokenAzureCsConnectorShQueryKey = (token: string,) => {
    return [`/Connection/scripts/${token}/azure-cs-connector.sh`] as const;
    }

    
export const getGetConnectionScriptsTokenAzureCsConnectorShQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>, TError = unknown>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsTokenAzureCsConnectorShQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>> = ({ signal }) => getConnectionScriptsTokenAzureCsConnectorSh(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsTokenAzureCsConnectorShQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>>
export type GetConnectionScriptsTokenAzureCsConnectorShQueryError = unknown

export const useGetConnectionScriptsTokenAzureCsConnectorSh = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>, TError = unknown>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorSh>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsTokenAzureCsConnectorShQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsTokenAzureCsConnectorPs1 = (
    token: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/${token}/azure-cs-connector.ps1`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsTokenAzureCsConnectorPs1QueryKey = (token: string,) => {
    return [`/Connection/scripts/${token}/azure-cs-connector.ps1`] as const;
    }

    
export const getGetConnectionScriptsTokenAzureCsConnectorPs1QueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>, TError = unknown>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsTokenAzureCsConnectorPs1QueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>> = ({ signal }) => getConnectionScriptsTokenAzureCsConnectorPs1(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsTokenAzureCsConnectorPs1QueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>>
export type GetConnectionScriptsTokenAzureCsConnectorPs1QueryError = unknown

export const useGetConnectionScriptsTokenAzureCsConnectorPs1 = <TData = Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>, TError = unknown>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsTokenAzureCsConnectorPs1>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsTokenAzureCsConnectorPs1QueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsCsTerraformTf = (
    params?: GetConnectionScriptsCsTerraformTfParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/cs-terraform.tf`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsCsTerraformTfQueryKey = (params?: GetConnectionScriptsCsTerraformTfParams,) => {
    return [`/Connection/scripts/cs-terraform.tf`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionScriptsCsTerraformTfQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>, TError = unknown>(params?: GetConnectionScriptsCsTerraformTfParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsCsTerraformTfQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>> = ({ signal }) => getConnectionScriptsCsTerraformTf(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsCsTerraformTfQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>>
export type GetConnectionScriptsCsTerraformTfQueryError = unknown

export const useGetConnectionScriptsCsTerraformTf = <TData = Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>, TError = unknown>(
 params?: GetConnectionScriptsCsTerraformTfParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsTerraformTf>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsCsTerraformTfQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsCsConnectArmJson = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/cs-connect-arm.json`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsCsConnectArmJsonQueryKey = () => {
    return [`/Connection/scripts/cs-connect-arm.json`] as const;
    }

    
export const getGetConnectionScriptsCsConnectArmJsonQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsCsConnectArmJsonQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>> = ({ signal }) => getConnectionScriptsCsConnectArmJson(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsCsConnectArmJsonQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>>
export type GetConnectionScriptsCsConnectArmJsonQueryError = unknown

export const useGetConnectionScriptsCsConnectArmJson = <TData = Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsConnectArmJson>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsCsConnectArmJsonQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsUpdateCsTerraformTf = (
    params?: GetConnectionScriptsUpdateCsTerraformTfParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/update-cs-terraform.tf`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsUpdateCsTerraformTfQueryKey = (params?: GetConnectionScriptsUpdateCsTerraformTfParams,) => {
    return [`/Connection/scripts/update-cs-terraform.tf`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionScriptsUpdateCsTerraformTfQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>, TError = unknown>(params?: GetConnectionScriptsUpdateCsTerraformTfParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsUpdateCsTerraformTfQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>> = ({ signal }) => getConnectionScriptsUpdateCsTerraformTf(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsUpdateCsTerraformTfQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>>
export type GetConnectionScriptsUpdateCsTerraformTfQueryError = unknown

export const useGetConnectionScriptsUpdateCsTerraformTf = <TData = Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>, TError = unknown>(
 params?: GetConnectionScriptsUpdateCsTerraformTfParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsTerraformTf>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsUpdateCsTerraformTfQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsCsCloudformationYml = (
    params?: GetConnectionScriptsCsCloudformationYmlParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/cs-cloudformation.yml`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsCsCloudformationYmlQueryKey = (params?: GetConnectionScriptsCsCloudformationYmlParams,) => {
    return [`/Connection/scripts/cs-cloudformation.yml`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionScriptsCsCloudformationYmlQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>, TError = unknown>(params?: GetConnectionScriptsCsCloudformationYmlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsCsCloudformationYmlQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>> = ({ signal }) => getConnectionScriptsCsCloudformationYml(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsCsCloudformationYmlQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>>
export type GetConnectionScriptsCsCloudformationYmlQueryError = unknown

export const useGetConnectionScriptsCsCloudformationYml = <TData = Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>, TError = unknown>(
 params?: GetConnectionScriptsCsCloudformationYmlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsCsCloudformationYml>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsCsCloudformationYmlQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionScriptsUpdateCsCloudformationYml = (
    params?: GetConnectionScriptsUpdateCsCloudformationYmlParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/scripts/update-cs-cloudformation.yml`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionScriptsUpdateCsCloudformationYmlQueryKey = (params?: GetConnectionScriptsUpdateCsCloudformationYmlParams,) => {
    return [`/Connection/scripts/update-cs-cloudformation.yml`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionScriptsUpdateCsCloudformationYmlQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>, TError = unknown>(params?: GetConnectionScriptsUpdateCsCloudformationYmlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionScriptsUpdateCsCloudformationYmlQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>> = ({ signal }) => getConnectionScriptsUpdateCsCloudformationYml(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionScriptsUpdateCsCloudformationYmlQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>>
export type GetConnectionScriptsUpdateCsCloudformationYmlQueryError = unknown

export const useGetConnectionScriptsUpdateCsCloudformationYml = <TData = Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>, TError = unknown>(
 params?: GetConnectionScriptsUpdateCsCloudformationYmlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionScriptsUpdateCsCloudformationYml>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionScriptsUpdateCsCloudformationYmlQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionGetPermissionList = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<PermissionList>(
      {url: `/Connection/GetPermissionList`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionGetPermissionListQueryKey = () => {
    return [`/Connection/GetPermissionList`] as const;
    }

    
export const getGetConnectionGetPermissionListQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionGetPermissionList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetPermissionList>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionGetPermissionListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionGetPermissionList>>> = ({ signal }) => getConnectionGetPermissionList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetPermissionList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionGetPermissionListQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionGetPermissionList>>>
export type GetConnectionGetPermissionListQueryError = unknown

export const useGetConnectionGetPermissionList = <TData = Awaited<ReturnType<typeof getConnectionGetPermissionList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetPermissionList>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionGetPermissionListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionGetAwsPolicyVersion = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsPolicyVersionInfo>(
      {url: `/Connection/GetAwsPolicyVersion`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionGetAwsPolicyVersionQueryKey = () => {
    return [`/Connection/GetAwsPolicyVersion`] as const;
    }

    
export const getGetConnectionGetAwsPolicyVersionQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionGetAwsPolicyVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>> = ({ signal }) => getConnectionGetAwsPolicyVersion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionGetAwsPolicyVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>>
export type GetConnectionGetAwsPolicyVersionQueryError = unknown

export const useGetConnectionGetAwsPolicyVersion = <TData = Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetAwsPolicyVersion>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionGetAwsPolicyVersionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionTryAssumeRole = (
    params?: GetConnectionTryAssumeRoleParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AssumeRolResult>(
      {url: `/Connection/TryAssumeRole`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionTryAssumeRoleQueryKey = (params?: GetConnectionTryAssumeRoleParams,) => {
    return [`/Connection/TryAssumeRole`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionTryAssumeRoleQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionTryAssumeRole>>, TError = unknown>(params?: GetConnectionTryAssumeRoleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionTryAssumeRole>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionTryAssumeRoleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionTryAssumeRole>>> = ({ signal }) => getConnectionTryAssumeRole(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionTryAssumeRole>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionTryAssumeRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionTryAssumeRole>>>
export type GetConnectionTryAssumeRoleQueryError = unknown

export const useGetConnectionTryAssumeRole = <TData = Awaited<ReturnType<typeof getConnectionTryAssumeRole>>, TError = unknown>(
 params?: GetConnectionTryAssumeRoleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionTryAssumeRole>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionTryAssumeRoleQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postConnectionPreparePolicy = (
    params?: PostConnectionPreparePolicyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/Connection/PreparePolicy`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionPreparePolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionPreparePolicy>>, TError,{params?: PostConnectionPreparePolicyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionPreparePolicy>>, TError,{params?: PostConnectionPreparePolicyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionPreparePolicy>>, {params?: PostConnectionPreparePolicyParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionPreparePolicy(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionPreparePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionPreparePolicy>>>
    
    export type PostConnectionPreparePolicyMutationError = unknown

    export const usePostConnectionPreparePolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionPreparePolicy>>, TError,{params?: PostConnectionPreparePolicyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionPreparePolicy>>,
        TError,
        {params?: PostConnectionPreparePolicyParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionPreparePolicyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetRoleYML = (
    params?: PostConnectionGetRoleYMLParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/Connection/GetRoleYML`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetRoleYMLMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetRoleYML>>, TError,{params?: PostConnectionGetRoleYMLParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetRoleYML>>, TError,{params?: PostConnectionGetRoleYMLParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetRoleYML>>, {params?: PostConnectionGetRoleYMLParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionGetRoleYML(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetRoleYMLMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetRoleYML>>>
    
    export type PostConnectionGetRoleYMLMutationError = unknown

    export const usePostConnectionGetRoleYML = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetRoleYML>>, TError,{params?: PostConnectionGetRoleYMLParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetRoleYML>>,
        TError,
        {params?: PostConnectionGetRoleYMLParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionGetRoleYMLMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetPendingConnection = (
    params?: PostConnectionGetPendingConnectionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PendingCliConnection>(
      {url: `/Connection/GetPendingConnection`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetPendingConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetPendingConnection>>, TError,{params?: PostConnectionGetPendingConnectionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetPendingConnection>>, TError,{params?: PostConnectionGetPendingConnectionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetPendingConnection>>, {params?: PostConnectionGetPendingConnectionParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionGetPendingConnection(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetPendingConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetPendingConnection>>>
    
    export type PostConnectionGetPendingConnectionMutationError = unknown

    export const usePostConnectionGetPendingConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetPendingConnection>>, TError,{params?: PostConnectionGetPendingConnectionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetPendingConnection>>,
        TError,
        {params?: PostConnectionGetPendingConnectionParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionGetPendingConnectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionConnect = (
    params?: PostConnectionConnectParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/Connect`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionConnectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionConnect>>, TError,{params?: PostConnectionConnectParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionConnect>>, TError,{params?: PostConnectionConnectParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionConnect>>, {params?: PostConnectionConnectParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionConnect(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionConnectMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionConnect>>>
    
    export type PostConnectionConnectMutationError = unknown

    export const usePostConnectionConnect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionConnect>>, TError,{params?: PostConnectionConnectParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionConnect>>,
        TError,
        {params?: PostConnectionConnectParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionConnectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionDisconnectAccount = (
    params?: PostConnectionDisconnectAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AccountDisconnectionSummary>(
      {url: `/Connection/DisconnectAccount`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionDisconnectAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionDisconnectAccount>>, TError,{params?: PostConnectionDisconnectAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionDisconnectAccount>>, TError,{params?: PostConnectionDisconnectAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionDisconnectAccount>>, {params?: PostConnectionDisconnectAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionDisconnectAccount(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionDisconnectAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionDisconnectAccount>>>
    
    export type PostConnectionDisconnectAccountMutationError = unknown

    export const usePostConnectionDisconnectAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionDisconnectAccount>>, TError,{params?: PostConnectionDisconnectAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionDisconnectAccount>>,
        TError,
        {params?: PostConnectionDisconnectAccountParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionDisconnectAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionDisconnectCloudsaverIntegration = (
    params?: PostConnectionDisconnectCloudsaverIntegrationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AccountDisconnectionSummary>(
      {url: `/Connection/DisconnectCloudsaverIntegration`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionDisconnectCloudsaverIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionDisconnectCloudsaverIntegration>>, TError,{params?: PostConnectionDisconnectCloudsaverIntegrationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionDisconnectCloudsaverIntegration>>, TError,{params?: PostConnectionDisconnectCloudsaverIntegrationParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionDisconnectCloudsaverIntegration>>, {params?: PostConnectionDisconnectCloudsaverIntegrationParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionDisconnectCloudsaverIntegration(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionDisconnectCloudsaverIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionDisconnectCloudsaverIntegration>>>
    
    export type PostConnectionDisconnectCloudsaverIntegrationMutationError = unknown

    export const usePostConnectionDisconnectCloudsaverIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionDisconnectCloudsaverIntegration>>, TError,{params?: PostConnectionDisconnectCloudsaverIntegrationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionDisconnectCloudsaverIntegration>>,
        TError,
        {params?: PostConnectionDisconnectCloudsaverIntegrationParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionDisconnectCloudsaverIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionRecordCLIError = (
    params?: PostConnectionRecordCLIErrorParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/RecordCLIError`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionRecordCLIErrorMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionRecordCLIError>>, TError,{params?: PostConnectionRecordCLIErrorParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionRecordCLIError>>, TError,{params?: PostConnectionRecordCLIErrorParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionRecordCLIError>>, {params?: PostConnectionRecordCLIErrorParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionRecordCLIError(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionRecordCLIErrorMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionRecordCLIError>>>
    
    export type PostConnectionRecordCLIErrorMutationError = unknown

    export const usePostConnectionRecordCLIError = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionRecordCLIError>>, TError,{params?: PostConnectionRecordCLIErrorParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionRecordCLIError>>,
        TError,
        {params?: PostConnectionRecordCLIErrorParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionRecordCLIErrorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionApplyAzureTenantCredentials = (
    azureSubscriptionConnection: AzureSubscriptionConnection[],
    params?: PostConnectionApplyAzureTenantCredentialsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/ApplyAzureTenantCredentials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: azureSubscriptionConnection,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionApplyAzureTenantCredentialsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionApplyAzureTenantCredentials>>, TError,{data: AzureSubscriptionConnection[];params?: PostConnectionApplyAzureTenantCredentialsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionApplyAzureTenantCredentials>>, TError,{data: AzureSubscriptionConnection[];params?: PostConnectionApplyAzureTenantCredentialsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionApplyAzureTenantCredentials>>, {data: AzureSubscriptionConnection[];params?: PostConnectionApplyAzureTenantCredentialsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postConnectionApplyAzureTenantCredentials(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionApplyAzureTenantCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionApplyAzureTenantCredentials>>>
    export type PostConnectionApplyAzureTenantCredentialsMutationBody = AzureSubscriptionConnection[]
    export type PostConnectionApplyAzureTenantCredentialsMutationError = unknown

    export const usePostConnectionApplyAzureTenantCredentials = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionApplyAzureTenantCredentials>>, TError,{data: AzureSubscriptionConnection[];params?: PostConnectionApplyAzureTenantCredentialsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionApplyAzureTenantCredentials>>,
        TError,
        {data: AzureSubscriptionConnection[];params?: PostConnectionApplyAzureTenantCredentialsParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionApplyAzureTenantCredentialsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionAddAzureSubscription = (
    azureConnectingSubscriptionInfo: AzureConnectingSubscriptionInfo[],
    params?: PostConnectionAddAzureSubscriptionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/AddAzureSubscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: azureConnectingSubscriptionInfo,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionAddAzureSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionAddAzureSubscription>>, TError,{data: AzureConnectingSubscriptionInfo[];params?: PostConnectionAddAzureSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionAddAzureSubscription>>, TError,{data: AzureConnectingSubscriptionInfo[];params?: PostConnectionAddAzureSubscriptionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionAddAzureSubscription>>, {data: AzureConnectingSubscriptionInfo[];params?: PostConnectionAddAzureSubscriptionParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postConnectionAddAzureSubscription(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionAddAzureSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionAddAzureSubscription>>>
    export type PostConnectionAddAzureSubscriptionMutationBody = AzureConnectingSubscriptionInfo[]
    export type PostConnectionAddAzureSubscriptionMutationError = unknown

    export const usePostConnectionAddAzureSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionAddAzureSubscription>>, TError,{data: AzureConnectingSubscriptionInfo[];params?: PostConnectionAddAzureSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionAddAzureSubscription>>,
        TError,
        {data: AzureConnectingSubscriptionInfo[];params?: PostConnectionAddAzureSubscriptionParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionAddAzureSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getConnectionConnectionComplete = (
    params?: GetConnectionConnectionCompleteParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ConnectResult>(
      {url: `/Connection/ConnectionComplete`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionConnectionCompleteQueryKey = (params?: GetConnectionConnectionCompleteParams,) => {
    return [`/Connection/ConnectionComplete`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionConnectionCompleteQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionConnectionComplete>>, TError = unknown>(params?: GetConnectionConnectionCompleteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionConnectionComplete>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionConnectionCompleteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionConnectionComplete>>> = ({ signal }) => getConnectionConnectionComplete(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionConnectionComplete>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionConnectionCompleteQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionConnectionComplete>>>
export type GetConnectionConnectionCompleteQueryError = unknown

export const useGetConnectionConnectionComplete = <TData = Awaited<ReturnType<typeof getConnectionConnectionComplete>>, TError = unknown>(
 params?: GetConnectionConnectionCompleteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionConnectionComplete>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionConnectionCompleteQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postConnectionSendSecondaryAccountConnectionMessage = (
    params?: PostConnectionSendSecondaryAccountConnectionMessageParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/SendSecondaryAccountConnectionMessage`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionSendSecondaryAccountConnectionMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionSendSecondaryAccountConnectionMessage>>, TError,{params?: PostConnectionSendSecondaryAccountConnectionMessageParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionSendSecondaryAccountConnectionMessage>>, TError,{params?: PostConnectionSendSecondaryAccountConnectionMessageParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionSendSecondaryAccountConnectionMessage>>, {params?: PostConnectionSendSecondaryAccountConnectionMessageParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionSendSecondaryAccountConnectionMessage(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionSendSecondaryAccountConnectionMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionSendSecondaryAccountConnectionMessage>>>
    
    export type PostConnectionSendSecondaryAccountConnectionMessageMutationError = unknown

    export const usePostConnectionSendSecondaryAccountConnectionMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionSendSecondaryAccountConnectionMessage>>, TError,{params?: PostConnectionSendSecondaryAccountConnectionMessageParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionSendSecondaryAccountConnectionMessage>>,
        TError,
        {params?: PostConnectionSendSecondaryAccountConnectionMessageParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionSendSecondaryAccountConnectionMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionSendConnectionConfirmationEmail = (
    params?: PostConnectionSendConnectionConfirmationEmailParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/SendConnectionConfirmationEmail`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionSendConnectionConfirmationEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionSendConnectionConfirmationEmail>>, TError,{params?: PostConnectionSendConnectionConfirmationEmailParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionSendConnectionConfirmationEmail>>, TError,{params?: PostConnectionSendConnectionConfirmationEmailParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionSendConnectionConfirmationEmail>>, {params?: PostConnectionSendConnectionConfirmationEmailParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionSendConnectionConfirmationEmail(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionSendConnectionConfirmationEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionSendConnectionConfirmationEmail>>>
    
    export type PostConnectionSendConnectionConfirmationEmailMutationError = unknown

    export const usePostConnectionSendConnectionConfirmationEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionSendConnectionConfirmationEmail>>, TError,{params?: PostConnectionSendConnectionConfirmationEmailParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionSendConnectionConfirmationEmail>>,
        TError,
        {params?: PostConnectionSendConnectionConfirmationEmailParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionSendConnectionConfirmationEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionAuthorizeAzureConnection = (
    params?: PostConnectionAuthorizeAzureConnectionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/AuthorizeAzureConnection`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionAuthorizeAzureConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionAuthorizeAzureConnection>>, TError,{params?: PostConnectionAuthorizeAzureConnectionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionAuthorizeAzureConnection>>, TError,{params?: PostConnectionAuthorizeAzureConnectionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionAuthorizeAzureConnection>>, {params?: PostConnectionAuthorizeAzureConnectionParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionAuthorizeAzureConnection(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionAuthorizeAzureConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionAuthorizeAzureConnection>>>
    
    export type PostConnectionAuthorizeAzureConnectionMutationError = unknown

    export const usePostConnectionAuthorizeAzureConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionAuthorizeAzureConnection>>, TError,{params?: PostConnectionAuthorizeAzureConnectionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionAuthorizeAzureConnection>>,
        TError,
        {params?: PostConnectionAuthorizeAzureConnectionParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionAuthorizeAzureConnectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getConnectionAzureConnectionCallback = (
    params?: GetConnectionAzureConnectionCallbackParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/AzureConnectionCallback`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionAzureConnectionCallbackQueryKey = (params?: GetConnectionAzureConnectionCallbackParams,) => {
    return [`/Connection/AzureConnectionCallback`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionAzureConnectionCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>, TError = unknown>(params?: GetConnectionAzureConnectionCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionAzureConnectionCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>> = ({ signal }) => getConnectionAzureConnectionCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionAzureConnectionCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>>
export type GetConnectionAzureConnectionCallbackQueryError = unknown

export const useGetConnectionAzureConnectionCallback = <TData = Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>, TError = unknown>(
 params?: GetConnectionAzureConnectionCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionAzureConnectionCallback>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionAzureConnectionCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionGetAzureConnectionStatus = (
    params?: GetConnectionGetAzureConnectionStatusParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AzureConnectionStatus>(
      {url: `/Connection/GetAzureConnectionStatus`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionGetAzureConnectionStatusQueryKey = (params?: GetConnectionGetAzureConnectionStatusParams,) => {
    return [`/Connection/GetAzureConnectionStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionGetAzureConnectionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>, TError = unknown>(params?: GetConnectionGetAzureConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionGetAzureConnectionStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>> = ({ signal }) => getConnectionGetAzureConnectionStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionGetAzureConnectionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>>
export type GetConnectionGetAzureConnectionStatusQueryError = unknown

export const useGetConnectionGetAzureConnectionStatus = <TData = Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>, TError = unknown>(
 params?: GetConnectionGetAzureConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetAzureConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionGetAzureConnectionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postConnectionCompleteAzureConnection = (
    azureConnectionRequest: AzureConnectionRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AzureSubscriptionProvisioningJob>(
      {url: `/Connection/CompleteAzureConnection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: azureConnectionRequest
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionCompleteAzureConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionCompleteAzureConnection>>, TError,{data: AzureConnectionRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionCompleteAzureConnection>>, TError,{data: AzureConnectionRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionCompleteAzureConnection>>, {data: AzureConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postConnectionCompleteAzureConnection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionCompleteAzureConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionCompleteAzureConnection>>>
    export type PostConnectionCompleteAzureConnectionMutationBody = AzureConnectionRequest
    export type PostConnectionCompleteAzureConnectionMutationError = unknown

    export const usePostConnectionCompleteAzureConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionCompleteAzureConnection>>, TError,{data: AzureConnectionRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionCompleteAzureConnection>>,
        TError,
        {data: AzureConnectionRequest},
        TContext
      > => {

      const mutationOptions = getPostConnectionCompleteAzureConnectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetAzureSubscriptionConnectabilityStatus = (
    postConnectionGetAzureSubscriptionConnectabilityStatusBody: string[],
    params?: PostConnectionGetAzureSubscriptionConnectabilityStatusParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AzureSubscriptionConnectability[]>(
      {url: `/Connection/GetAzureSubscriptionConnectabilityStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postConnectionGetAzureSubscriptionConnectabilityStatusBody,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetAzureSubscriptionConnectabilityStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetAzureSubscriptionConnectabilityStatus>>, TError,{data: string[];params?: PostConnectionGetAzureSubscriptionConnectabilityStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetAzureSubscriptionConnectabilityStatus>>, TError,{data: string[];params?: PostConnectionGetAzureSubscriptionConnectabilityStatusParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetAzureSubscriptionConnectabilityStatus>>, {data: string[];params?: PostConnectionGetAzureSubscriptionConnectabilityStatusParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postConnectionGetAzureSubscriptionConnectabilityStatus(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetAzureSubscriptionConnectabilityStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetAzureSubscriptionConnectabilityStatus>>>
    export type PostConnectionGetAzureSubscriptionConnectabilityStatusMutationBody = string[]
    export type PostConnectionGetAzureSubscriptionConnectabilityStatusMutationError = unknown

    export const usePostConnectionGetAzureSubscriptionConnectabilityStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetAzureSubscriptionConnectabilityStatus>>, TError,{data: string[];params?: PostConnectionGetAzureSubscriptionConnectabilityStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetAzureSubscriptionConnectabilityStatus>>,
        TError,
        {data: string[];params?: PostConnectionGetAzureSubscriptionConnectabilityStatusParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionGetAzureSubscriptionConnectabilityStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionAuthorizeGcpConnection = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/AuthorizeGcpConnection`, method: 'POST'
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionAuthorizeGcpConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionAuthorizeGcpConnection>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionAuthorizeGcpConnection>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionAuthorizeGcpConnection>>, void> = () => {
          

          return  postConnectionAuthorizeGcpConnection(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionAuthorizeGcpConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionAuthorizeGcpConnection>>>
    
    export type PostConnectionAuthorizeGcpConnectionMutationError = unknown

    export const usePostConnectionAuthorizeGcpConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionAuthorizeGcpConnection>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionAuthorizeGcpConnection>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostConnectionAuthorizeGcpConnectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getConnectionGcpConnectionCallback = (
    params?: GetConnectionGcpConnectionCallbackParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Connection/GcpConnectionCallback`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionGcpConnectionCallbackQueryKey = (params?: GetConnectionGcpConnectionCallbackParams,) => {
    return [`/Connection/GcpConnectionCallback`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionGcpConnectionCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>, TError = unknown>(params?: GetConnectionGcpConnectionCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionGcpConnectionCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>> = ({ signal }) => getConnectionGcpConnectionCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionGcpConnectionCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>>
export type GetConnectionGcpConnectionCallbackQueryError = unknown

export const useGetConnectionGcpConnectionCallback = <TData = Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>, TError = unknown>(
 params?: GetConnectionGcpConnectionCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGcpConnectionCallback>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionGcpConnectionCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getConnectionGetGcpConnectionStatus = (
    params?: GetConnectionGetGcpConnectionStatusParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GcpConnectionStatus>(
      {url: `/Connection/GetGcpConnectionStatus`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetConnectionGetGcpConnectionStatusQueryKey = (params?: GetConnectionGetGcpConnectionStatusParams,) => {
    return [`/Connection/GetGcpConnectionStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetConnectionGetGcpConnectionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>, TError = unknown>(params?: GetConnectionGetGcpConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionGetGcpConnectionStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>> = ({ signal }) => getConnectionGetGcpConnectionStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectionGetGcpConnectionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>>
export type GetConnectionGetGcpConnectionStatusQueryError = unknown

export const useGetConnectionGetGcpConnectionStatus = <TData = Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>, TError = unknown>(
 params?: GetConnectionGetGcpConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectionGetGcpConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConnectionGetGcpConnectionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postConnectionCompleteGcpConnection = (
    gcpConnectionRequest: GcpConnectionRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GcpProjectProvisioningJob>(
      {url: `/Connection/CompleteGcpConnection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gcpConnectionRequest
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionCompleteGcpConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionCompleteGcpConnection>>, TError,{data: GcpConnectionRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionCompleteGcpConnection>>, TError,{data: GcpConnectionRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionCompleteGcpConnection>>, {data: GcpConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postConnectionCompleteGcpConnection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionCompleteGcpConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionCompleteGcpConnection>>>
    export type PostConnectionCompleteGcpConnectionMutationBody = GcpConnectionRequest
    export type PostConnectionCompleteGcpConnectionMutationError = unknown

    export const usePostConnectionCompleteGcpConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionCompleteGcpConnection>>, TError,{data: GcpConnectionRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionCompleteGcpConnection>>,
        TError,
        {data: GcpConnectionRequest},
        TContext
      > => {

      const mutationOptions = getPostConnectionCompleteGcpConnectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetGcpProjectConnectabilityStatus = (
    postConnectionGetGcpProjectConnectabilityStatusBody: string[],
    params?: PostConnectionGetGcpProjectConnectabilityStatusParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GcpProjectConnectability[]>(
      {url: `/Connection/GetGcpProjectConnectabilityStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postConnectionGetGcpProjectConnectabilityStatusBody,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetGcpProjectConnectabilityStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpProjectConnectabilityStatus>>, TError,{data: string[];params?: PostConnectionGetGcpProjectConnectabilityStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpProjectConnectabilityStatus>>, TError,{data: string[];params?: PostConnectionGetGcpProjectConnectabilityStatusParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetGcpProjectConnectabilityStatus>>, {data: string[];params?: PostConnectionGetGcpProjectConnectabilityStatusParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postConnectionGetGcpProjectConnectabilityStatus(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetGcpProjectConnectabilityStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetGcpProjectConnectabilityStatus>>>
    export type PostConnectionGetGcpProjectConnectabilityStatusMutationBody = string[]
    export type PostConnectionGetGcpProjectConnectabilityStatusMutationError = unknown

    export const usePostConnectionGetGcpProjectConnectabilityStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpProjectConnectabilityStatus>>, TError,{data: string[];params?: PostConnectionGetGcpProjectConnectabilityStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetGcpProjectConnectabilityStatus>>,
        TError,
        {data: string[];params?: PostConnectionGetGcpProjectConnectabilityStatusParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionGetGcpProjectConnectabilityStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetGcpConnectionUrl = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Connection/GetGcpConnectionUrl`, method: 'POST'
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetGcpConnectionUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpConnectionUrl>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpConnectionUrl>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetGcpConnectionUrl>>, void> = () => {
          

          return  postConnectionGetGcpConnectionUrl(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetGcpConnectionUrlMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetGcpConnectionUrl>>>
    
    export type PostConnectionGetGcpConnectionUrlMutationError = unknown

    export const usePostConnectionGetGcpConnectionUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpConnectionUrl>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetGcpConnectionUrl>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostConnectionGetGcpConnectionUrlMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetGcpAccessTokenFromCode = (
    params?: PostConnectionGetGcpAccessTokenFromCodeParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GcpToken>(
      {url: `/Connection/GetGcpAccessTokenFromCode`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetGcpAccessTokenFromCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpAccessTokenFromCode>>, TError,{params?: PostConnectionGetGcpAccessTokenFromCodeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpAccessTokenFromCode>>, TError,{params?: PostConnectionGetGcpAccessTokenFromCodeParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetGcpAccessTokenFromCode>>, {params?: PostConnectionGetGcpAccessTokenFromCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  postConnectionGetGcpAccessTokenFromCode(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetGcpAccessTokenFromCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetGcpAccessTokenFromCode>>>
    
    export type PostConnectionGetGcpAccessTokenFromCodeMutationError = unknown

    export const usePostConnectionGetGcpAccessTokenFromCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpAccessTokenFromCode>>, TError,{params?: PostConnectionGetGcpAccessTokenFromCodeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetGcpAccessTokenFromCode>>,
        TError,
        {params?: PostConnectionGetGcpAccessTokenFromCodeParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionGetGcpAccessTokenFromCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postConnectionGetGcpBillingInfo = (
    postConnectionGetGcpBillingInfoBody: string[],
    params?: PostConnectionGetGcpBillingInfoParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GcpBillingExportInfo>(
      {url: `/Connection/GetGcpBillingInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postConnectionGetGcpBillingInfoBody,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostConnectionGetGcpBillingInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpBillingInfo>>, TError,{data: string[];params?: PostConnectionGetGcpBillingInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpBillingInfo>>, TError,{data: string[];params?: PostConnectionGetGcpBillingInfoParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConnectionGetGcpBillingInfo>>, {data: string[];params?: PostConnectionGetGcpBillingInfoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postConnectionGetGcpBillingInfo(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConnectionGetGcpBillingInfoMutationResult = NonNullable<Awaited<ReturnType<typeof postConnectionGetGcpBillingInfo>>>
    export type PostConnectionGetGcpBillingInfoMutationBody = string[]
    export type PostConnectionGetGcpBillingInfoMutationError = unknown

    export const usePostConnectionGetGcpBillingInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConnectionGetGcpBillingInfo>>, TError,{data: string[];params?: PostConnectionGetGcpBillingInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postConnectionGetGcpBillingInfo>>,
        TError,
        {data: string[];params?: PostConnectionGetGcpBillingInfoParams},
        TContext
      > => {

      const mutationOptions = getPostConnectionGetGcpBillingInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postIdleActionStartIdleResources = (
    selectedIdleResourceRequest: SelectedIdleResourceRequest[],
    params?: PostIdleActionStartIdleResourcesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/IdleAction/StartIdleResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selectedIdleResourceRequest,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostIdleActionStartIdleResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIdleActionStartIdleResources>>, TError,{data: SelectedIdleResourceRequest[];params?: PostIdleActionStartIdleResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postIdleActionStartIdleResources>>, TError,{data: SelectedIdleResourceRequest[];params?: PostIdleActionStartIdleResourcesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIdleActionStartIdleResources>>, {data: SelectedIdleResourceRequest[];params?: PostIdleActionStartIdleResourcesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postIdleActionStartIdleResources(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIdleActionStartIdleResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postIdleActionStartIdleResources>>>
    export type PostIdleActionStartIdleResourcesMutationBody = SelectedIdleResourceRequest[]
    export type PostIdleActionStartIdleResourcesMutationError = unknown

    export const usePostIdleActionStartIdleResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIdleActionStartIdleResources>>, TError,{data: SelectedIdleResourceRequest[];params?: PostIdleActionStartIdleResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postIdleActionStartIdleResources>>,
        TError,
        {data: SelectedIdleResourceRequest[];params?: PostIdleActionStartIdleResourcesParams},
        TContext
      > => {

      const mutationOptions = getPostIdleActionStartIdleResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postIdleActionStopIdleResources = (
    selectedIdleResourceRequest: SelectedIdleResourceRequest[],
    params?: PostIdleActionStopIdleResourcesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/IdleAction/StopIdleResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selectedIdleResourceRequest,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostIdleActionStopIdleResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIdleActionStopIdleResources>>, TError,{data: SelectedIdleResourceRequest[];params?: PostIdleActionStopIdleResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postIdleActionStopIdleResources>>, TError,{data: SelectedIdleResourceRequest[];params?: PostIdleActionStopIdleResourcesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIdleActionStopIdleResources>>, {data: SelectedIdleResourceRequest[];params?: PostIdleActionStopIdleResourcesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postIdleActionStopIdleResources(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIdleActionStopIdleResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postIdleActionStopIdleResources>>>
    export type PostIdleActionStopIdleResourcesMutationBody = SelectedIdleResourceRequest[]
    export type PostIdleActionStopIdleResourcesMutationError = unknown

    export const usePostIdleActionStopIdleResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIdleActionStopIdleResources>>, TError,{data: SelectedIdleResourceRequest[];params?: PostIdleActionStopIdleResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postIdleActionStopIdleResources>>,
        TError,
        {data: SelectedIdleResourceRequest[];params?: PostIdleActionStopIdleResourcesParams},
        TContext
      > => {

      const mutationOptions = getPostIdleActionStopIdleResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMetadataIntegrationGetSchema = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SchemaType[]>(
      {url: `/MetadataIntegration/GetSchema`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetMetadataIntegrationGetSchemaQueryKey = () => {
    return [`/MetadataIntegration/GetSchema`] as const;
    }

    
export const getGetMetadataIntegrationGetSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetadataIntegrationGetSchemaQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>> = ({ signal }) => getMetadataIntegrationGetSchema(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetadataIntegrationGetSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>>
export type GetMetadataIntegrationGetSchemaQueryError = unknown

export const useGetMetadataIntegrationGetSchema = <TData = Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetSchema>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetadataIntegrationGetSchemaQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMetadataIntegrationGetSchemaByCompanyId = (
    params?: GetMetadataIntegrationGetSchemaByCompanyIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SchemaType[]>(
      {url: `/MetadataIntegration/GetSchemaByCompanyId`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetMetadataIntegrationGetSchemaByCompanyIdQueryKey = (params?: GetMetadataIntegrationGetSchemaByCompanyIdParams,) => {
    return [`/MetadataIntegration/GetSchemaByCompanyId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMetadataIntegrationGetSchemaByCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>, TError = unknown>(params?: GetMetadataIntegrationGetSchemaByCompanyIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetadataIntegrationGetSchemaByCompanyIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>> = ({ signal }) => getMetadataIntegrationGetSchemaByCompanyId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetadataIntegrationGetSchemaByCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>>
export type GetMetadataIntegrationGetSchemaByCompanyIdQueryError = unknown

export const useGetMetadataIntegrationGetSchemaByCompanyId = <TData = Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>, TError = unknown>(
 params?: GetMetadataIntegrationGetSchemaByCompanyIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetSchemaByCompanyId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetadataIntegrationGetSchemaByCompanyIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMetadataIntegration = (
    params?: GetMetadataIntegrationParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MetadataIntegrationConfig[]>(
      {url: `/MetadataIntegration`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetMetadataIntegrationQueryKey = (params?: GetMetadataIntegrationParams,) => {
    return [`/MetadataIntegration`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMetadataIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof getMetadataIntegration>>, TError = unknown>(params?: GetMetadataIntegrationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegration>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetadataIntegrationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetadataIntegration>>> = ({ signal }) => getMetadataIntegration(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegration>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetadataIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getMetadataIntegration>>>
export type GetMetadataIntegrationQueryError = unknown

export const useGetMetadataIntegration = <TData = Awaited<ReturnType<typeof getMetadataIntegration>>, TError = unknown>(
 params?: GetMetadataIntegrationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegration>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetadataIntegrationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMetadataIntegrationGetDimensionMetadata = (
    params?: GetMetadataIntegrationGetDimensionMetadataParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/MetadataIntegration/GetDimensionMetadata`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetMetadataIntegrationGetDimensionMetadataQueryKey = (params?: GetMetadataIntegrationGetDimensionMetadataParams,) => {
    return [`/MetadataIntegration/GetDimensionMetadata`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMetadataIntegrationGetDimensionMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>, TError = unknown>(params?: GetMetadataIntegrationGetDimensionMetadataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetadataIntegrationGetDimensionMetadataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>> = ({ signal }) => getMetadataIntegrationGetDimensionMetadata(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetadataIntegrationGetDimensionMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>>
export type GetMetadataIntegrationGetDimensionMetadataQueryError = unknown

export const useGetMetadataIntegrationGetDimensionMetadata = <TData = Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>, TError = unknown>(
 params?: GetMetadataIntegrationGetDimensionMetadataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetadataIntegrationGetDimensionMetadata>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetadataIntegrationGetDimensionMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMetadataIntegrationSearch = (
    query: Query,
    params?: PostMetadataIntegrationSearchParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/MetadataIntegration/Search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostMetadataIntegrationSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMetadataIntegrationSearch>>, TError,{data: Query;params?: PostMetadataIntegrationSearchParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMetadataIntegrationSearch>>, TError,{data: Query;params?: PostMetadataIntegrationSearchParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMetadataIntegrationSearch>>, {data: Query;params?: PostMetadataIntegrationSearchParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postMetadataIntegrationSearch(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMetadataIntegrationSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postMetadataIntegrationSearch>>>
    export type PostMetadataIntegrationSearchMutationBody = Query
    export type PostMetadataIntegrationSearchMutationError = unknown

    export const usePostMetadataIntegrationSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMetadataIntegrationSearch>>, TError,{data: Query;params?: PostMetadataIntegrationSearchParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMetadataIntegrationSearch>>,
        TError,
        {data: Query;params?: PostMetadataIntegrationSearchParams},
        TContext
      > => {

      const mutationOptions = getPostMetadataIntegrationSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postObservabilityQuery = (
    metricQuery: MetricQuery,
    params?: PostObservabilityQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MetricResults>(
      {url: `/Observability/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: metricQuery,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostObservabilityQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postObservabilityQuery>>, TError,{data: MetricQuery;params?: PostObservabilityQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postObservabilityQuery>>, TError,{data: MetricQuery;params?: PostObservabilityQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postObservabilityQuery>>, {data: MetricQuery;params?: PostObservabilityQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postObservabilityQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostObservabilityQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postObservabilityQuery>>>
    export type PostObservabilityQueryMutationBody = MetricQuery
    export type PostObservabilityQueryMutationError = unknown

    export const usePostObservabilityQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postObservabilityQuery>>, TError,{data: MetricQuery;params?: PostObservabilityQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postObservabilityQuery>>,
        TError,
        {data: MetricQuery;params?: PostObservabilityQueryParams},
        TContext
      > => {

      const mutationOptions = getPostObservabilityQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getObservabilityGetMetricTypes = (
    params?: GetObservabilityGetMetricTypesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Observability/GetMetricTypes`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetObservabilityGetMetricTypesQueryKey = (params?: GetObservabilityGetMetricTypesParams,) => {
    return [`/Observability/GetMetricTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetObservabilityGetMetricTypesQueryOptions = <TData = Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>, TError = unknown>(params?: GetObservabilityGetMetricTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetObservabilityGetMetricTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>> = ({ signal }) => getObservabilityGetMetricTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetObservabilityGetMetricTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>>
export type GetObservabilityGetMetricTypesQueryError = unknown

export const useGetObservabilityGetMetricTypes = <TData = Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>, TError = unknown>(
 params?: GetObservabilityGetMetricTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getObservabilityGetMetricTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetObservabilityGetMetricTypesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRecommendations = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<unknown[]>(
      {url: `/Recommendations`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetRecommendationsQueryKey = () => {
    return [`/Recommendations`] as const;
    }

    
export const getGetRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof getRecommendations>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecommendations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecommendationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecommendations>>> = ({ signal }) => getRecommendations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecommendations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof getRecommendations>>>
export type GetRecommendationsQueryError = unknown

export const useGetRecommendations = <TData = Awaited<ReturnType<typeof getRecommendations>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecommendations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRecommendationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postResourceChangedUpsertResourceChanged = (
    resourceChange: ResourceChange[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/ResourceChanged/UpsertResourceChanged`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resourceChange
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceChangedUpsertResourceChangedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedUpsertResourceChanged>>, TError,{data: ResourceChange[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedUpsertResourceChanged>>, TError,{data: ResourceChange[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceChangedUpsertResourceChanged>>, {data: ResourceChange[]}> = (props) => {
          const {data} = props ?? {};

          return  postResourceChangedUpsertResourceChanged(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceChangedUpsertResourceChangedMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceChangedUpsertResourceChanged>>>
    export type PostResourceChangedUpsertResourceChangedMutationBody = ResourceChange[]
    export type PostResourceChangedUpsertResourceChangedMutationError = unknown

    export const usePostResourceChangedUpsertResourceChanged = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedUpsertResourceChanged>>, TError,{data: ResourceChange[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceChangedUpsertResourceChanged>>,
        TError,
        {data: ResourceChange[]},
        TContext
      > => {

      const mutationOptions = getPostResourceChangedUpsertResourceChangedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceChangedQueryResourceChangeLog = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourceChanged/QueryResourceChangeLog`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceChangedQueryResourceChangeLogMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLog>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLog>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLog>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourceChangedQueryResourceChangeLog(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceChangedQueryResourceChangeLogMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLog>>>
    export type PostResourceChangedQueryResourceChangeLogMutationBody = Query
    export type PostResourceChangedQueryResourceChangeLogMutationError = unknown

    export const usePostResourceChangedQueryResourceChangeLog = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLog>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLog>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourceChangedQueryResourceChangeLogMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceChangedQueryResourceChangeLogStream = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/ResourceChanged/QueryResourceChangeLogStream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceChangedQueryResourceChangeLogStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLogStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLogStream>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLogStream>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourceChangedQueryResourceChangeLogStream(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceChangedQueryResourceChangeLogStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLogStream>>>
    export type PostResourceChangedQueryResourceChangeLogStreamMutationBody = Query
    export type PostResourceChangedQueryResourceChangeLogStreamMutationError = unknown

    export const usePostResourceChangedQueryResourceChangeLogStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLogStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceChangedQueryResourceChangeLogStream>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourceChangedQueryResourceChangeLogStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceChangedSearch = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ResourceChangeQueryResult>(
      {url: `/ResourceChanged/Search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceChangedSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedSearch>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedSearch>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceChangedSearch>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourceChangedSearch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceChangedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceChangedSearch>>>
    export type PostResourceChangedSearchMutationBody = Query
    export type PostResourceChangedSearchMutationError = unknown

    export const usePostResourceChangedSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceChangedSearch>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceChangedSearch>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourceChangedSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcePricingGetAwsPricing = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourcePricing/GetAwsPricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcePricingGetAwsPricingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsPricing>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsPricing>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcePricingGetAwsPricing>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourcePricingGetAwsPricing(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcePricingGetAwsPricingMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcePricingGetAwsPricing>>>
    export type PostResourcePricingGetAwsPricingMutationBody = Query
    export type PostResourcePricingGetAwsPricingMutationError = unknown

    export const usePostResourcePricingGetAwsPricing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsPricing>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcePricingGetAwsPricing>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourcePricingGetAwsPricingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcePricingQueryAwsPricing = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourcePricing/QueryAwsPricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcePricingQueryAwsPricingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsPricing>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsPricing>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcePricingQueryAwsPricing>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourcePricingQueryAwsPricing(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcePricingQueryAwsPricingMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcePricingQueryAwsPricing>>>
    export type PostResourcePricingQueryAwsPricingMutationBody = Query
    export type PostResourcePricingQueryAwsPricingMutationError = unknown

    export const usePostResourcePricingQueryAwsPricing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsPricing>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcePricingQueryAwsPricing>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourcePricingQueryAwsPricingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcePricingGetAwsAttributes = (
    query: Query,
    params?: PostResourcePricingGetAwsAttributesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourcePricing/GetAwsAttributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcePricingGetAwsAttributesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsAttributes>>, TError,{data: Query;params?: PostResourcePricingGetAwsAttributesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsAttributes>>, TError,{data: Query;params?: PostResourcePricingGetAwsAttributesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcePricingGetAwsAttributes>>, {data: Query;params?: PostResourcePricingGetAwsAttributesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcePricingGetAwsAttributes(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcePricingGetAwsAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcePricingGetAwsAttributes>>>
    export type PostResourcePricingGetAwsAttributesMutationBody = Query
    export type PostResourcePricingGetAwsAttributesMutationError = unknown

    export const usePostResourcePricingGetAwsAttributes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsAttributes>>, TError,{data: Query;params?: PostResourcePricingGetAwsAttributesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcePricingGetAwsAttributes>>,
        TError,
        {data: Query;params?: PostResourcePricingGetAwsAttributesParams},
        TContext
      > => {

      const mutationOptions = getPostResourcePricingGetAwsAttributesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcePricingQueryAwsAttributes = (
    query: Query,
    params?: PostResourcePricingQueryAwsAttributesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourcePricing/QueryAwsAttributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcePricingQueryAwsAttributesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsAttributes>>, TError,{data: Query;params?: PostResourcePricingQueryAwsAttributesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsAttributes>>, TError,{data: Query;params?: PostResourcePricingQueryAwsAttributesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcePricingQueryAwsAttributes>>, {data: Query;params?: PostResourcePricingQueryAwsAttributesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcePricingQueryAwsAttributes(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcePricingQueryAwsAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcePricingQueryAwsAttributes>>>
    export type PostResourcePricingQueryAwsAttributesMutationBody = Query
    export type PostResourcePricingQueryAwsAttributesMutationError = unknown

    export const usePostResourcePricingQueryAwsAttributes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsAttributes>>, TError,{data: Query;params?: PostResourcePricingQueryAwsAttributesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcePricingQueryAwsAttributes>>,
        TError,
        {data: Query;params?: PostResourcePricingQueryAwsAttributesParams},
        TContext
      > => {

      const mutationOptions = getPostResourcePricingQueryAwsAttributesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcePricingQueryAwsReservedPricing = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourcePricing/QueryAwsReservedPricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcePricingQueryAwsReservedPricingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsReservedPricing>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsReservedPricing>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcePricingQueryAwsReservedPricing>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourcePricingQueryAwsReservedPricing(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcePricingQueryAwsReservedPricingMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcePricingQueryAwsReservedPricing>>>
    export type PostResourcePricingQueryAwsReservedPricingMutationBody = Query
    export type PostResourcePricingQueryAwsReservedPricingMutationError = unknown

    export const usePostResourcePricingQueryAwsReservedPricing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingQueryAwsReservedPricing>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcePricingQueryAwsReservedPricing>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourcePricingQueryAwsReservedPricingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcePricingGetAwsOnDemandPricing = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<OnDemandPricing[]>(
      {url: `/ResourcePricing/GetAwsOnDemandPricing`, method: 'POST'
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcePricingGetAwsOnDemandPricingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsOnDemandPricing>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsOnDemandPricing>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcePricingGetAwsOnDemandPricing>>, void> = () => {
          

          return  postResourcePricingGetAwsOnDemandPricing(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcePricingGetAwsOnDemandPricingMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcePricingGetAwsOnDemandPricing>>>
    
    export type PostResourcePricingGetAwsOnDemandPricingMutationError = unknown

    export const usePostResourcePricingGetAwsOnDemandPricing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcePricingGetAwsOnDemandPricing>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcePricingGetAwsOnDemandPricing>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostResourcePricingGetAwsOnDemandPricingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getResources = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<unknown[]>(
      {url: `/Resources`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesQueryKey = () => {
    return [`/Resources`] as const;
    }

    
export const getGetResourcesQueryOptions = <TData = Awaited<ReturnType<typeof getResources>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResources>>> = ({ signal }) => getResources(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getResources>>>
export type GetResourcesQueryError = unknown

export const useGetResources = <TData = Awaited<ReturnType<typeof getResources>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResources>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getResourcesGetResourceHierarchyLookup = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetResourcesGetResourceHierarchyLookup200One | GetResourcesGetResourceHierarchyLookup200Two | GetResourcesGetResourceHierarchyLookup200Three>(
      {url: `/Resources/GetResourceHierarchyLookup`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesGetResourceHierarchyLookupQueryKey = () => {
    return [`/Resources/GetResourceHierarchyLookup`] as const;
    }

    
export const getGetResourcesGetResourceHierarchyLookupQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetResourceHierarchyLookupQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>> = ({ signal }) => getResourcesGetResourceHierarchyLookup(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetResourceHierarchyLookupQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>>
export type GetResourcesGetResourceHierarchyLookupQueryError = unknown

export const useGetResourcesGetResourceHierarchyLookup = <TData = Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetResourceHierarchyLookup>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetResourceHierarchyLookupQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getResourcesGetPossibleChildrenOrDefault = (
    params?: GetResourcesGetPossibleChildrenOrDefaultParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string[]>(
      {url: `/Resources/GetPossibleChildrenOrDefault`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesGetPossibleChildrenOrDefaultQueryKey = (params?: GetResourcesGetPossibleChildrenOrDefaultParams,) => {
    return [`/Resources/GetPossibleChildrenOrDefault`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResourcesGetPossibleChildrenOrDefaultQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>, TError = unknown>(params?: GetResourcesGetPossibleChildrenOrDefaultParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetPossibleChildrenOrDefaultQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>> = ({ signal }) => getResourcesGetPossibleChildrenOrDefault(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetPossibleChildrenOrDefaultQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>>
export type GetResourcesGetPossibleChildrenOrDefaultQueryError = unknown

export const useGetResourcesGetPossibleChildrenOrDefault = <TData = Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>, TError = unknown>(
 params?: GetResourcesGetPossibleChildrenOrDefaultParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetPossibleChildrenOrDefault>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetPossibleChildrenOrDefaultQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getResourcesGetParentResourceTypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string[]>(
      {url: `/Resources/GetParentResourceTypes`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesGetParentResourceTypesQueryKey = () => {
    return [`/Resources/GetParentResourceTypes`] as const;
    }

    
export const getGetResourcesGetParentResourceTypesQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetParentResourceTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>> = ({ signal }) => getResourcesGetParentResourceTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetParentResourceTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>>
export type GetResourcesGetParentResourceTypesQueryError = unknown

export const useGetResourcesGetParentResourceTypes = <TData = Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetParentResourceTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetParentResourceTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postResourcesGetChildResources = (
    baseResource: BaseResource,
    params?: PostResourcesGetChildResourcesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BaseResource[]>(
      {url: `/Resources/GetChildResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseResource,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesGetChildResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetChildResources>>, TError,{data: BaseResource;params?: PostResourcesGetChildResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetChildResources>>, TError,{data: BaseResource;params?: PostResourcesGetChildResourcesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesGetChildResources>>, {data: BaseResource;params?: PostResourcesGetChildResourcesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesGetChildResources(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesGetChildResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesGetChildResources>>>
    export type PostResourcesGetChildResourcesMutationBody = BaseResource
    export type PostResourcesGetChildResourcesMutationError = unknown

    export const usePostResourcesGetChildResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetChildResources>>, TError,{data: BaseResource;params?: PostResourcesGetChildResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesGetChildResources>>,
        TError,
        {data: BaseResource;params?: PostResourcesGetChildResourcesParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesGetChildResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesGetParentResource = (
    baseResource: BaseResource,
    params?: PostResourcesGetParentResourceParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BaseResource>(
      {url: `/Resources/GetParentResource`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseResource,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesGetParentResourceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetParentResource>>, TError,{data: BaseResource;params?: PostResourcesGetParentResourceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetParentResource>>, TError,{data: BaseResource;params?: PostResourcesGetParentResourceParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesGetParentResource>>, {data: BaseResource;params?: PostResourcesGetParentResourceParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesGetParentResource(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesGetParentResourceMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesGetParentResource>>>
    export type PostResourcesGetParentResourceMutationBody = BaseResource
    export type PostResourcesGetParentResourceMutationError = unknown

    export const usePostResourcesGetParentResource = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetParentResource>>, TError,{data: BaseResource;params?: PostResourcesGetParentResourceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesGetParentResource>>,
        TError,
        {data: BaseResource;params?: PostResourcesGetParentResourceParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesGetParentResourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesEnrichResourceHierarchy = (
    awsHierarchyEnrichment: AwsHierarchyEnrichment,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Resources/EnrichResourceHierarchy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: awsHierarchyEnrichment
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesEnrichResourceHierarchyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesEnrichResourceHierarchy>>, TError,{data: AwsHierarchyEnrichment}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesEnrichResourceHierarchy>>, TError,{data: AwsHierarchyEnrichment}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesEnrichResourceHierarchy>>, {data: AwsHierarchyEnrichment}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesEnrichResourceHierarchy(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesEnrichResourceHierarchyMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesEnrichResourceHierarchy>>>
    export type PostResourcesEnrichResourceHierarchyMutationBody = AwsHierarchyEnrichment
    export type PostResourcesEnrichResourceHierarchyMutationError = unknown

    export const usePostResourcesEnrichResourceHierarchy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesEnrichResourceHierarchy>>, TError,{data: AwsHierarchyEnrichment}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesEnrichResourceHierarchy>>,
        TError,
        {data: AwsHierarchyEnrichment},
        TContext
      > => {

      const mutationOptions = getPostResourcesEnrichResourceHierarchyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesQuery = (
    query: Query,
    params?: PostResourcesQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/Resources/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesQuery>>, TError,{data: Query;params?: PostResourcesQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesQuery>>, TError,{data: Query;params?: PostResourcesQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesQuery>>, {data: Query;params?: PostResourcesQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesQuery>>>
    export type PostResourcesQueryMutationBody = Query
    export type PostResourcesQueryMutationError = unknown

    export const usePostResourcesQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesQuery>>, TError,{data: Query;params?: PostResourcesQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesQuery>>,
        TError,
        {data: Query;params?: PostResourcesQueryParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesMultiQuery = (
    query: Query[],
    params?: PostResourcesMultiQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/Resources/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesMultiQuery>>, TError,{data: Query[];params?: PostResourcesMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesMultiQuery>>, TError,{data: Query[];params?: PostResourcesMultiQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesMultiQuery>>, {data: Query[];params?: PostResourcesMultiQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesMultiQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesMultiQuery>>>
    export type PostResourcesMultiQueryMutationBody = Query[]
    export type PostResourcesMultiQueryMutationError = unknown

    export const usePostResourcesMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesMultiQuery>>, TError,{data: Query[];params?: PostResourcesMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesMultiQuery>>,
        TError,
        {data: Query[];params?: PostResourcesMultiQueryParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesStream = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/Resources/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesStream>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesStream>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesStream(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesStream>>>
    export type PostResourcesStreamMutationBody = Query
    export type PostResourcesStreamMutationError = unknown

    export const usePostResourcesStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesStream>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourcesStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesSearch = (
    query: Query,
    params?: PostResourcesSearchParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BaseResourceQueryResult>(
      {url: `/Resources/Search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesSearch>>, TError,{data: Query;params?: PostResourcesSearchParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesSearch>>, TError,{data: Query;params?: PostResourcesSearchParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesSearch>>, {data: Query;params?: PostResourcesSearchParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesSearch(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesSearch>>>
    export type PostResourcesSearchMutationBody = Query
    export type PostResourcesSearchMutationError = unknown

    export const usePostResourcesSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesSearch>>, TError,{data: Query;params?: PostResourcesSearchParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesSearch>>,
        TError,
        {data: Query;params?: PostResourcesSearchParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesCheckAwsResources = (
    checkAwsResources: CheckAwsResources,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CheckAwsResourcesJob>(
      {url: `/Resources/CheckAwsResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkAwsResources
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesCheckAwsResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesCheckAwsResources>>, TError,{data: CheckAwsResources}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesCheckAwsResources>>, TError,{data: CheckAwsResources}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesCheckAwsResources>>, {data: CheckAwsResources}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesCheckAwsResources(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesCheckAwsResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesCheckAwsResources>>>
    export type PostResourcesCheckAwsResourcesMutationBody = CheckAwsResources
    export type PostResourcesCheckAwsResourcesMutationError = unknown

    export const usePostResourcesCheckAwsResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesCheckAwsResources>>, TError,{data: CheckAwsResources}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesCheckAwsResources>>,
        TError,
        {data: CheckAwsResources},
        TContext
      > => {

      const mutationOptions = getPostResourcesCheckAwsResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesCheckAzureResources = (
    checkAzureResources: CheckAzureResources,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CheckAzureResourcesJob>(
      {url: `/Resources/CheckAzureResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkAzureResources
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesCheckAzureResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesCheckAzureResources>>, TError,{data: CheckAzureResources}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesCheckAzureResources>>, TError,{data: CheckAzureResources}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesCheckAzureResources>>, {data: CheckAzureResources}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesCheckAzureResources(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesCheckAzureResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesCheckAzureResources>>>
    export type PostResourcesCheckAzureResourcesMutationBody = CheckAzureResources
    export type PostResourcesCheckAzureResourcesMutationError = unknown

    export const usePostResourcesCheckAzureResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesCheckAzureResources>>, TError,{data: CheckAzureResources}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesCheckAzureResources>>,
        TError,
        {data: CheckAzureResources},
        TContext
      > => {

      const mutationOptions = getPostResourcesCheckAzureResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesTagResources = (
    tagResourcesJob: TagResourcesJob,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagResourcesJobJob>(
      {url: `/Resources/TagResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagResourcesJob
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesTagResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesTagResources>>, TError,{data: TagResourcesJob}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesTagResources>>, TError,{data: TagResourcesJob}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesTagResources>>, {data: TagResourcesJob}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesTagResources(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesTagResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesTagResources>>>
    export type PostResourcesTagResourcesMutationBody = TagResourcesJob
    export type PostResourcesTagResourcesMutationError = unknown

    export const usePostResourcesTagResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesTagResources>>, TError,{data: TagResourcesJob}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesTagResources>>,
        TError,
        {data: TagResourcesJob},
        TContext
      > => {

      const mutationOptions = getPostResourcesTagResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesBulkUpdateTagResources = (
    tagResourcesJob: TagResourcesJob[],
    params?: PostResourcesBulkUpdateTagResourcesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Resources/BulkUpdateTagResources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagResourcesJob,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesBulkUpdateTagResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesBulkUpdateTagResources>>, TError,{data: TagResourcesJob[];params?: PostResourcesBulkUpdateTagResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesBulkUpdateTagResources>>, TError,{data: TagResourcesJob[];params?: PostResourcesBulkUpdateTagResourcesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesBulkUpdateTagResources>>, {data: TagResourcesJob[];params?: PostResourcesBulkUpdateTagResourcesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesBulkUpdateTagResources(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesBulkUpdateTagResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesBulkUpdateTagResources>>>
    export type PostResourcesBulkUpdateTagResourcesMutationBody = TagResourcesJob[]
    export type PostResourcesBulkUpdateTagResourcesMutationError = unknown

    export const usePostResourcesBulkUpdateTagResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesBulkUpdateTagResources>>, TError,{data: TagResourcesJob[];params?: PostResourcesBulkUpdateTagResourcesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesBulkUpdateTagResources>>,
        TError,
        {data: TagResourcesJob[];params?: PostResourcesBulkUpdateTagResourcesParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesBulkUpdateTagResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesUpdateEventBridgeRules = (
    params?: PostResourcesUpdateEventBridgeRulesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Resources/UpdateEventBridgeRules`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesUpdateEventBridgeRulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesUpdateEventBridgeRules>>, TError,{params?: PostResourcesUpdateEventBridgeRulesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesUpdateEventBridgeRules>>, TError,{params?: PostResourcesUpdateEventBridgeRulesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesUpdateEventBridgeRules>>, {params?: PostResourcesUpdateEventBridgeRulesParams}> = (props) => {
          const {params} = props ?? {};

          return  postResourcesUpdateEventBridgeRules(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesUpdateEventBridgeRulesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesUpdateEventBridgeRules>>>
    
    export type PostResourcesUpdateEventBridgeRulesMutationError = unknown

    export const usePostResourcesUpdateEventBridgeRules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesUpdateEventBridgeRules>>, TError,{params?: PostResourcesUpdateEventBridgeRulesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesUpdateEventBridgeRules>>,
        TError,
        {params?: PostResourcesUpdateEventBridgeRulesParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesUpdateEventBridgeRulesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesTagResource = (
    tagResourcesJob: TagResourcesJob,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagResourceResult>(
      {url: `/Resources/TagResource`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagResourcesJob
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesTagResourceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesTagResource>>, TError,{data: TagResourcesJob}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesTagResource>>, TError,{data: TagResourcesJob}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesTagResource>>, {data: TagResourcesJob}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesTagResource(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesTagResourceMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesTagResource>>>
    export type PostResourcesTagResourceMutationBody = TagResourcesJob
    export type PostResourcesTagResourceMutationError = unknown

    export const usePostResourcesTagResource = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesTagResource>>, TError,{data: TagResourcesJob}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesTagResource>>,
        TError,
        {data: TagResourcesJob},
        TContext
      > => {

      const mutationOptions = getPostResourcesTagResourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesCancelTagging = (
    params?: PostResourcesCancelTaggingParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Resources/CancelTagging`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesCancelTaggingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesCancelTagging>>, TError,{params?: PostResourcesCancelTaggingParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesCancelTagging>>, TError,{params?: PostResourcesCancelTaggingParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesCancelTagging>>, {params?: PostResourcesCancelTaggingParams}> = (props) => {
          const {params} = props ?? {};

          return  postResourcesCancelTagging(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesCancelTaggingMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesCancelTagging>>>
    
    export type PostResourcesCancelTaggingMutationError = unknown

    export const usePostResourcesCancelTagging = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesCancelTagging>>, TError,{params?: PostResourcesCancelTaggingParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesCancelTagging>>,
        TError,
        {params?: PostResourcesCancelTaggingParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesCancelTaggingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourcesGetCompanyEventBridgeHistory = (
    query: Query,
    params?: PostResourcesGetCompanyEventBridgeHistoryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AwsEventBridgeHistoryQueryResult>(
      {url: `/Resources/GetCompanyEventBridgeHistory`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesGetCompanyEventBridgeHistoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetCompanyEventBridgeHistory>>, TError,{data: Query;params?: PostResourcesGetCompanyEventBridgeHistoryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetCompanyEventBridgeHistory>>, TError,{data: Query;params?: PostResourcesGetCompanyEventBridgeHistoryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesGetCompanyEventBridgeHistory>>, {data: Query;params?: PostResourcesGetCompanyEventBridgeHistoryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourcesGetCompanyEventBridgeHistory(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesGetCompanyEventBridgeHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesGetCompanyEventBridgeHistory>>>
    export type PostResourcesGetCompanyEventBridgeHistoryMutationBody = Query
    export type PostResourcesGetCompanyEventBridgeHistoryMutationError = unknown

    export const usePostResourcesGetCompanyEventBridgeHistory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesGetCompanyEventBridgeHistory>>, TError,{data: Query;params?: PostResourcesGetCompanyEventBridgeHistoryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesGetCompanyEventBridgeHistory>>,
        TError,
        {data: Query;params?: PostResourcesGetCompanyEventBridgeHistoryParams},
        TContext
      > => {

      const mutationOptions = getPostResourcesGetCompanyEventBridgeHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getResourcesGetAwsPolicyResourceTypeMatrix = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetResourcesGetAwsPolicyResourceTypeMatrix200One | GetResourcesGetAwsPolicyResourceTypeMatrix200Two | GetResourcesGetAwsPolicyResourceTypeMatrix200Three>(
      {url: `/Resources/GetAwsPolicyResourceTypeMatrix`, method: 'GET', signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesGetAwsPolicyResourceTypeMatrixQueryKey = () => {
    return [`/Resources/GetAwsPolicyResourceTypeMatrix`] as const;
    }

    
export const getGetResourcesGetAwsPolicyResourceTypeMatrixQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetAwsPolicyResourceTypeMatrixQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>> = ({ signal }) => getResourcesGetAwsPolicyResourceTypeMatrix(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetAwsPolicyResourceTypeMatrixQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>>
export type GetResourcesGetAwsPolicyResourceTypeMatrixQueryError = unknown

export const useGetResourcesGetAwsPolicyResourceTypeMatrix = <TData = Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetAwsPolicyResourceTypeMatrix>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetAwsPolicyResourceTypeMatrixQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getResourcesGetOrganizationalHierarchy = (
    params?: GetResourcesGetOrganizationalHierarchyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ResourceHierarchy>(
      {url: `/Resources/GetOrganizationalHierarchy`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesGetOrganizationalHierarchyQueryKey = (params?: GetResourcesGetOrganizationalHierarchyParams,) => {
    return [`/Resources/GetOrganizationalHierarchy`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResourcesGetOrganizationalHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>, TError = unknown>(params?: GetResourcesGetOrganizationalHierarchyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetOrganizationalHierarchyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>> = ({ signal }) => getResourcesGetOrganizationalHierarchy(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetOrganizationalHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>>
export type GetResourcesGetOrganizationalHierarchyQueryError = unknown

export const useGetResourcesGetOrganizationalHierarchy = <TData = Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>, TError = unknown>(
 params?: GetResourcesGetOrganizationalHierarchyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchy>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetOrganizationalHierarchyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getResourcesGetOrganizationalHierarchyByName = (
    params?: GetResourcesGetOrganizationalHierarchyByNameParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ResourceHierarchy>(
      {url: `/Resources/GetOrganizationalHierarchyByName`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetResourcesGetOrganizationalHierarchyByNameQueryKey = (params?: GetResourcesGetOrganizationalHierarchyByNameParams,) => {
    return [`/Resources/GetOrganizationalHierarchyByName`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResourcesGetOrganizationalHierarchyByNameQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>, TError = unknown>(params?: GetResourcesGetOrganizationalHierarchyByNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetOrganizationalHierarchyByNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>> = ({ signal }) => getResourcesGetOrganizationalHierarchyByName(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetOrganizationalHierarchyByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>>
export type GetResourcesGetOrganizationalHierarchyByNameQueryError = unknown

export const useGetResourcesGetOrganizationalHierarchyByName = <TData = Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>, TError = unknown>(
 params?: GetResourcesGetOrganizationalHierarchyByNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetOrganizationalHierarchyByName>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetOrganizationalHierarchyByNameQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postResourcesExternalChangeDetected = (
    aPIGatewayProxyRequest: APIGatewayProxyRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Resources/ExternalChangeDetected`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aPIGatewayProxyRequest
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourcesExternalChangeDetectedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesExternalChangeDetected>>, TError,{data: APIGatewayProxyRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesExternalChangeDetected>>, TError,{data: APIGatewayProxyRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesExternalChangeDetected>>, {data: APIGatewayProxyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesExternalChangeDetected(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesExternalChangeDetectedMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesExternalChangeDetected>>>
    export type PostResourcesExternalChangeDetectedMutationBody = APIGatewayProxyRequest
    export type PostResourcesExternalChangeDetectedMutationError = unknown

    export const usePostResourcesExternalChangeDetected = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesExternalChangeDetected>>, TError,{data: APIGatewayProxyRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesExternalChangeDetected>>,
        TError,
        {data: APIGatewayProxyRequest},
        TContext
      > => {

      const mutationOptions = getPostResourcesExternalChangeDetectedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceSnapshotQuerySnapshots = (
    query: Query,
    params?: PostResourceSnapshotQuerySnapshotsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourceSnapshot/QuerySnapshots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceSnapshotQuerySnapshotsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceSnapshotQuerySnapshots>>, TError,{data: Query;params?: PostResourceSnapshotQuerySnapshotsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceSnapshotQuerySnapshots>>, TError,{data: Query;params?: PostResourceSnapshotQuerySnapshotsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceSnapshotQuerySnapshots>>, {data: Query;params?: PostResourceSnapshotQuerySnapshotsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResourceSnapshotQuerySnapshots(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceSnapshotQuerySnapshotsMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceSnapshotQuerySnapshots>>>
    export type PostResourceSnapshotQuerySnapshotsMutationBody = Query
    export type PostResourceSnapshotQuerySnapshotsMutationError = unknown

    export const usePostResourceSnapshotQuerySnapshots = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceSnapshotQuerySnapshots>>, TError,{data: Query;params?: PostResourceSnapshotQuerySnapshotsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceSnapshotQuerySnapshots>>,
        TError,
        {data: Query;params?: PostResourceSnapshotQuerySnapshotsParams},
        TContext
      > => {

      const mutationOptions = getPostResourceSnapshotQuerySnapshotsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceSyncStatusQuery = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResourceSyncStatus/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceSyncStatusQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceSyncStatusQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceSyncStatusQuery>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceSyncStatusQuery>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postResourceSyncStatusQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceSyncStatusQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceSyncStatusQuery>>>
    export type PostResourceSyncStatusQueryMutationBody = Query
    export type PostResourceSyncStatusQueryMutationError = unknown

    export const usePostResourceSyncStatusQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceSyncStatusQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceSyncStatusQuery>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostResourceSyncStatusQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceTagAutomationGetRulePreviewCount = (
    tagAutomationRule: TagAutomationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PreviewCountAndQuery>(
      {url: `/ResourceTagAutomation/GetRulePreviewCount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationRule
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceTagAutomationGetRulePreviewCountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewCount>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewCount>>, TError,{data: TagAutomationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewCount>>, {data: TagAutomationRule}> = (props) => {
          const {data} = props ?? {};

          return  postResourceTagAutomationGetRulePreviewCount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceTagAutomationGetRulePreviewCountMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewCount>>>
    export type PostResourceTagAutomationGetRulePreviewCountMutationBody = TagAutomationRule
    export type PostResourceTagAutomationGetRulePreviewCountMutationError = unknown

    export const usePostResourceTagAutomationGetRulePreviewCount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewCount>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewCount>>,
        TError,
        {data: TagAutomationRule},
        TContext
      > => {

      const mutationOptions = getPostResourceTagAutomationGetRulePreviewCountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceTagAutomationGetRulePreviewChanges = (
    tagAutomationRule: TagAutomationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ResourceChangePreviewModel[]>(
      {url: `/ResourceTagAutomation/GetRulePreviewChanges`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationRule
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceTagAutomationGetRulePreviewChangesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewChanges>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewChanges>>, TError,{data: TagAutomationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewChanges>>, {data: TagAutomationRule}> = (props) => {
          const {data} = props ?? {};

          return  postResourceTagAutomationGetRulePreviewChanges(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceTagAutomationGetRulePreviewChangesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewChanges>>>
    export type PostResourceTagAutomationGetRulePreviewChangesMutationBody = TagAutomationRule
    export type PostResourceTagAutomationGetRulePreviewChangesMutationError = unknown

    export const usePostResourceTagAutomationGetRulePreviewChanges = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewChanges>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceTagAutomationGetRulePreviewChanges>>,
        TError,
        {data: TagAutomationRule},
        TContext
      > => {

      const mutationOptions = getPostResourceTagAutomationGetRulePreviewChangesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceTagAutomationGetFilteredResourceTypes = (
    tagAutomationRule: TagAutomationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<FilteredResourceTypesAndCounts>(
      {url: `/ResourceTagAutomation/GetFilteredResourceTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationRule
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceTagAutomationGetFilteredResourceTypesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetFilteredResourceTypes>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetFilteredResourceTypes>>, TError,{data: TagAutomationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceTagAutomationGetFilteredResourceTypes>>, {data: TagAutomationRule}> = (props) => {
          const {data} = props ?? {};

          return  postResourceTagAutomationGetFilteredResourceTypes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceTagAutomationGetFilteredResourceTypesMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceTagAutomationGetFilteredResourceTypes>>>
    export type PostResourceTagAutomationGetFilteredResourceTypesMutationBody = TagAutomationRule
    export type PostResourceTagAutomationGetFilteredResourceTypesMutationError = unknown

    export const usePostResourceTagAutomationGetFilteredResourceTypes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetFilteredResourceTypes>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceTagAutomationGetFilteredResourceTypes>>,
        TError,
        {data: TagAutomationRule},
        TContext
      > => {

      const mutationOptions = getPostResourceTagAutomationGetFilteredResourceTypesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceTagAutomationGetInheritancePreviewCount = (
    tagAutomationRule: TagAutomationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/ResourceTagAutomation/GetInheritancePreviewCount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationRule
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceTagAutomationGetInheritancePreviewCountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetInheritancePreviewCount>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetInheritancePreviewCount>>, TError,{data: TagAutomationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceTagAutomationGetInheritancePreviewCount>>, {data: TagAutomationRule}> = (props) => {
          const {data} = props ?? {};

          return  postResourceTagAutomationGetInheritancePreviewCount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceTagAutomationGetInheritancePreviewCountMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceTagAutomationGetInheritancePreviewCount>>>
    export type PostResourceTagAutomationGetInheritancePreviewCountMutationBody = TagAutomationRule
    export type PostResourceTagAutomationGetInheritancePreviewCountMutationError = unknown

    export const usePostResourceTagAutomationGetInheritancePreviewCount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTagAutomationGetInheritancePreviewCount>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceTagAutomationGetInheritancePreviewCount>>,
        TError,
        {data: TagAutomationRule},
        TContext
      > => {

      const mutationOptions = getPostResourceTagAutomationGetInheritancePreviewCountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceTaggingEstimateTagJob = (
    tagResourcesJob: TagResourcesJob,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagJobEstimate>(
      {url: `/ResourceTagging/EstimateTagJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagResourcesJob
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceTaggingEstimateTagJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTaggingEstimateTagJob>>, TError,{data: TagResourcesJob}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceTaggingEstimateTagJob>>, TError,{data: TagResourcesJob}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceTaggingEstimateTagJob>>, {data: TagResourcesJob}> = (props) => {
          const {data} = props ?? {};

          return  postResourceTaggingEstimateTagJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceTaggingEstimateTagJobMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceTaggingEstimateTagJob>>>
    export type PostResourceTaggingEstimateTagJobMutationBody = TagResourcesJob
    export type PostResourceTaggingEstimateTagJobMutationError = unknown

    export const usePostResourceTaggingEstimateTagJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTaggingEstimateTagJob>>, TError,{data: TagResourcesJob}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceTaggingEstimateTagJob>>,
        TError,
        {data: TagResourcesJob},
        TContext
      > => {

      const mutationOptions = getPostResourceTaggingEstimateTagJobMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResourceTaggingRaiseTagAutomationEvent = (
    tagAutomationEvent: TagAutomationEvent,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/ResourceTagging/RaiseTagAutomationEvent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationEvent
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostResourceTaggingRaiseTagAutomationEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTaggingRaiseTagAutomationEvent>>, TError,{data: TagAutomationEvent}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourceTaggingRaiseTagAutomationEvent>>, TError,{data: TagAutomationEvent}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourceTaggingRaiseTagAutomationEvent>>, {data: TagAutomationEvent}> = (props) => {
          const {data} = props ?? {};

          return  postResourceTaggingRaiseTagAutomationEvent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceTaggingRaiseTagAutomationEventMutationResult = NonNullable<Awaited<ReturnType<typeof postResourceTaggingRaiseTagAutomationEvent>>>
    export type PostResourceTaggingRaiseTagAutomationEventMutationBody = TagAutomationEvent
    export type PostResourceTaggingRaiseTagAutomationEventMutationError = unknown

    export const usePostResourceTaggingRaiseTagAutomationEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourceTaggingRaiseTagAutomationEvent>>, TError,{data: TagAutomationEvent}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourceTaggingRaiseTagAutomationEvent>>,
        TError,
        {data: TagAutomationEvent},
        TContext
      > => {

      const mutationOptions = getPostResourceTaggingRaiseTagAutomationEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postSavedSearchSaveSearch = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<SavedSearchToken>(
      {url: `/SavedSearch/SaveSearch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostSavedSearchSaveSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSavedSearchSaveSearch>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSavedSearchSaveSearch>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSavedSearchSaveSearch>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postSavedSearchSaveSearch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSavedSearchSaveSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postSavedSearchSaveSearch>>>
    export type PostSavedSearchSaveSearchMutationBody = Query
    export type PostSavedSearchSaveSearchMutationError = unknown

    export const usePostSavedSearchSaveSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSavedSearchSaveSearch>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSavedSearchSaveSearch>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostSavedSearchSaveSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSavedSearchGetResults = (
    params?: GetSavedSearchGetResultsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SavedSearchResults>(
      {url: `/SavedSearch/GetResults`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetSavedSearchGetResultsQueryKey = (params?: GetSavedSearchGetResultsParams,) => {
    return [`/SavedSearch/GetResults`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSavedSearchGetResultsQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearchGetResults>>, TError = unknown>(params?: GetSavedSearchGetResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchGetResults>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchGetResultsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearchGetResults>>> = ({ signal }) => getSavedSearchGetResults(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchGetResults>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSavedSearchGetResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearchGetResults>>>
export type GetSavedSearchGetResultsQueryError = unknown

export const useGetSavedSearchGetResults = <TData = Awaited<ReturnType<typeof getSavedSearchGetResults>>, TError = unknown>(
 params?: GetSavedSearchGetResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchGetResults>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSavedSearchGetResultsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSavedSearchGetResources = (
    params?: GetSavedSearchGetResourcesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BaseResourceQueryResult>(
      {url: `/SavedSearch/GetResources`, method: 'GET',
        params, signal
    },
      { type: 'Resources',  ...options});
    }
  

export const getGetSavedSearchGetResourcesQueryKey = (params?: GetSavedSearchGetResourcesParams,) => {
    return [`/SavedSearch/GetResources`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSavedSearchGetResourcesQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearchGetResources>>, TError = unknown>(params?: GetSavedSearchGetResourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchGetResources>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchGetResourcesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearchGetResources>>> = ({ signal }) => getSavedSearchGetResources(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchGetResources>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSavedSearchGetResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearchGetResources>>>
export type GetSavedSearchGetResourcesQueryError = unknown

export const useGetSavedSearchGetResources = <TData = Awaited<ReturnType<typeof getSavedSearchGetResources>>, TError = unknown>(
 params?: GetSavedSearchGetResourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchGetResources>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSavedSearchGetResourcesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagPolicyGetPolicies = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AwsEffectiveTagPolicy[]>(
      {url: `/TagPolicy/GetPolicies`, method: 'POST'
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostTagPolicyGetPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyGetPolicies>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyGetPolicies>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagPolicyGetPolicies>>, void> = () => {
          

          return  postTagPolicyGetPolicies(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagPolicyGetPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagPolicyGetPolicies>>>
    
    export type PostTagPolicyGetPoliciesMutationError = unknown

    export const usePostTagPolicyGetPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyGetPolicies>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagPolicyGetPolicies>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTagPolicyGetPoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagPolicyImportPolicies = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagPolicy/ImportPolicies`, method: 'POST'
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostTagPolicyImportPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyImportPolicies>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyImportPolicies>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagPolicyImportPolicies>>, void> = () => {
          

          return  postTagPolicyImportPolicies(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagPolicyImportPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagPolicyImportPolicies>>>
    
    export type PostTagPolicyImportPoliciesMutationError = unknown

    export const usePostTagPolicyImportPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyImportPolicies>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagPolicyImportPolicies>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTagPolicyImportPoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagPolicyQueryAwsPolicies = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/TagPolicy/QueryAwsPolicies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostTagPolicyQueryAwsPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyQueryAwsPolicies>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyQueryAwsPolicies>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagPolicyQueryAwsPolicies>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagPolicyQueryAwsPolicies(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagPolicyQueryAwsPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagPolicyQueryAwsPolicies>>>
    export type PostTagPolicyQueryAwsPoliciesMutationBody = Query
    export type PostTagPolicyQueryAwsPoliciesMutationError = unknown

    export const usePostTagPolicyQueryAwsPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyQueryAwsPolicies>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagPolicyQueryAwsPolicies>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagPolicyQueryAwsPoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagPolicyGetAzureTagPolicies = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AzureTagPolicy[]>(
      {url: `/TagPolicy/GetAzureTagPolicies`, method: 'POST'
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostTagPolicyGetAzureTagPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyGetAzureTagPolicies>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyGetAzureTagPolicies>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagPolicyGetAzureTagPolicies>>, void> = () => {
          

          return  postTagPolicyGetAzureTagPolicies(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagPolicyGetAzureTagPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagPolicyGetAzureTagPolicies>>>
    
    export type PostTagPolicyGetAzureTagPoliciesMutationError = unknown

    export const usePostTagPolicyGetAzureTagPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyGetAzureTagPolicies>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagPolicyGetAzureTagPolicies>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTagPolicyGetAzureTagPoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagPolicyReimportAzureTagPolicies = (
    params?: PostTagPolicyReimportAzureTagPoliciesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AzureTagPolicy[]>(
      {url: `/TagPolicy/ReimportAzureTagPolicies`, method: 'POST',
        params
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostTagPolicyReimportAzureTagPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyReimportAzureTagPolicies>>, TError,{params?: PostTagPolicyReimportAzureTagPoliciesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyReimportAzureTagPolicies>>, TError,{params?: PostTagPolicyReimportAzureTagPoliciesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagPolicyReimportAzureTagPolicies>>, {params?: PostTagPolicyReimportAzureTagPoliciesParams}> = (props) => {
          const {params} = props ?? {};

          return  postTagPolicyReimportAzureTagPolicies(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagPolicyReimportAzureTagPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagPolicyReimportAzureTagPolicies>>>
    
    export type PostTagPolicyReimportAzureTagPoliciesMutationError = unknown

    export const usePostTagPolicyReimportAzureTagPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyReimportAzureTagPolicies>>, TError,{params?: PostTagPolicyReimportAzureTagPoliciesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagPolicyReimportAzureTagPolicies>>,
        TError,
        {params?: PostTagPolicyReimportAzureTagPoliciesParams},
        TContext
      > => {

      const mutationOptions = getPostTagPolicyReimportAzureTagPoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagPolicyQueryAzurePolicies = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/TagPolicy/QueryAzurePolicies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Resources',  ...options});
    }
  


export const getPostTagPolicyQueryAzurePoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyQueryAzurePolicies>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyQueryAzurePolicies>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagPolicyQueryAzurePolicies>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagPolicyQueryAzurePolicies(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagPolicyQueryAzurePoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagPolicyQueryAzurePolicies>>>
    export type PostTagPolicyQueryAzurePoliciesMutationBody = Query
    export type PostTagPolicyQueryAzurePoliciesMutationError = unknown

    export const usePostTagPolicyQueryAzurePolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagPolicyQueryAzurePolicies>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagPolicyQueryAzurePolicies>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagPolicyQueryAzurePoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
